<template>
  <form v-on:submit="nextClick">
    <div class="card card-info card-tabs">
      <div class="card-header p-0 pt-1 pl-1">
        <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist">
          <li class="nav-item">
            <a class="nav-link" v-bind:class="activetab == 2 ? 'active': 'disabled'" data-toggle="pill" href="#custom-tabs-four-home" role="tab" aria-controls="custom-tabs-four-home" aria-selected="true">1. Fee Structure (Regular)</a>
          </li>
          <!--<li class="nav-item">
            <a class="nav-link" v-bind:class="activetab == 3 ? 'active': 'disabled'" data-toggle="pill" href="#custom-tabs-four-profile" role="tab" aria-controls="custom-tabs-four-profile" aria-selected="false">2. Fee Structure (Self-Support)</a>
          </li>-->
        </ul>
      </div>

      <div class="card-body">
        <div class="tab-content active" id="custom-tabs-four-tabContent">
          <div class="tab-pane fade active show" id="custom-tabs-four-home" role="tabpanel" aria-labelledby="custom-tabs-four-home-tab">
            <div class="row" v-if="activetab == 2" id="divFeeStructure">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Program</label>
                  <select class="form-control" v-model="data1.ProgramID" required="required">
                    <option value="" disabled="disabled">--Select Program--</option>
                    <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Batch</label>
                  <select class="form-control" v-model="data1.SessionID" required="required" v-on:change="batchChange()">
                    <option value="" disabled="disabled">--Select Batch--</option>
                    <option v-for="item in sessions" v-bind:value="item.SessionID">{{item.Name}}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Category</label>
                  <select class="form-control" v-model="data1.CategoryID" required="required" v-on:change="categoryChange()">
                    <option value="" disabled="disabled">--Select Category--</option>
                    <option v-for="item in category" v-bind:value="item.AdmissionCategoryID">{{item.Name}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12" v-if="data1.CategoryID != ''">
                <div class="form-group">
                  <h3 style="margin-top: 10px">Regular <span v-if="data1.IsAnnual == 'True'">Years</span> <span v-if="data1.IsAnnual == 'False'">Semesters</span></h3>
                </div>
              </div>
              <div class="col-md-6" v-for="(item, ind) in feescheme" v-if="data1.CategoryID != ''">
                <div class="form-group"> 
                  <div style="border-top: 3px solid #343a40;"> 
                    <h4 v-if="data1.IsAnnual == 'True'">Year {{item.Num}}</h4>
                    <h4 v-if="data1.IsAnnual == 'False'">Semester {{item.Num}}</h4> 
                    <table class="table table-bordered table-sm table-striped table-color" style="font-size: 12px;">
                      <thead class="bg-info">
                        <tr>
                          <th width="50%" style="vertical-align: middle;">Fee Particular</th>
                          <th width="30%" style="text-align: center">Type</th>
                          <th style="text-align: center">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(f, i) in item.Child">
                          <td style="vertical-align: middle; width: 50%">{{f.Name}}</td>
                          <td v-if="ind == 0">
                            <select class="form-control" v-model="f.Type" v-on:change="feeTypeChange(f.Type, i)">
                              <option value="">--Select--</option>
                              <option value="Once">Once</option>
                              <option value="Annual">Annualy</option>
                              <option v-if="data1.IsAnnual == 'False'" value="Semester">Semester Wise</option>
                            </select>
                          </td>
                          <td width="30%" v-else>
                            <span v-if="f.Type == ''">Not Selected</span>
                            <span v-if="f.Type == 'Once'">Once</span>
                            <span v-if="f.Type == 'Annual'">Annualy</span>
                            <span v-if="f.Type == 'Semester'">Semester Wise</span>
                          </td>
                          <td v-if="ind == 0">
                            <input v-bind:disabled="f.Type == ''" style="text-align:right" class="form-control txtNumber" v-model="f.Fee" v-on:change="amountChange(f.Fee, i)" v-mask="'######'" required="required" />
                          </td>
                          <td v-else>
                            <input v-bind:disabled="f.Type == 'Once' || f.Type == ''" style="text-align:right" class="form-control txtNumber" v-model="f.Fee" v-mask="'######'" required="required" />
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="2" style="text-align: right">
                            <label>Total</label>
                          </td>
                          <td class="txtNumber" style="text-align:right">
                            <label>{{getTotal(ind).toLocaleString()}}</label>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                </div>
              </div>

              <div class="col-md-12" v-if="data1.CategoryID != ''">
                <div class="form-group" style="border-top: 3px solid #343a40; margin-top: 20px ">
                  <h3 style="margin-top: 10px">Exceptional <span v-if="data1.IsAnnual == 'True'">Years</span> <span v-if="data1.IsAnnual == 'False'">Semesters</span></h3>
                </div>
              </div>
              <div class="col-md-6" v-if="data1.CategoryID != ''">
                <div class="form-group">
                  <table class="table table-bordered table-sm table-striped table-color" style="font-size: 12px;">
                    <thead class="bg-info">
                      <tr>
                        <th width="50%" style="vertical-align: middle;">Fee Particular</th>
                        <th width="30%" style="text-align: center">Type</th>
                        <th style="text-align: center">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(f, ind) in feeexceptional">
                        <td style="vertical-align: middle; width: 30%">{{f.Name}}</td>
                        <td>
                          <select class="form-control" v-model="f.Type">
                            <option value="">--Select--</option>
                            <option value="Annual">Annualy</option>
                            <option v-if="data1.IsAnnual == 'False'" value="Semester">Semester Wise</option>
                          </select>
                        </td>
                        <td>
                          <input class="form-control txtNumber" style="text-align:right" v-bind:disabled="f.Type == ''" v-model="f.Fee" required="required" v-mask="'######'" />
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="2" style="text-align: right">
                          <label>Total</label>
                        </td>
                        <td class="txtNumber" style="text-align:right">
                          <label>{{getexecpTotal().toLocaleString()}}</label>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
            <div class="row" v-if="activetab == 3" id="divFeeStructure2">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Program: </label>
                  <select class="form-control" required="required" disabled>
                    <option value="0" selected="selected">{{programs.find(x => x.ProgramID == data1.ProgramID).ProgramName}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Batch</label>
                  <select class="form-control" disabled>
                    <option value="1" selected="selected">{{sessions.find(x => x.SessionID == data1.SessionID).Name}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <h3 style="margin-top: 10px">Regular <span v-if="data1.IsAnnual == 'True'">Years</span> <span v-if="data1.IsAnnual == 'False'">Semesters</span></h3>
                </div>
              </div>
              <div class="col-md-6" v-for="(item, ind) in feescheme2">
                <div class="form-group">
                  <div style="border-top: 3px solid #343a40;">
                    <h4 v-if="data1.IsAnnual == 'True'">Year {{item.Num}}</h4>
                    <h4 v-if="data1.IsAnnual == 'False'">Semester {{item.Num}}</h4>

                    <table width="100%" class="table table-bordered table-sm table-striped table-color " style="font-size: 12px;">
                      <thead class="bg-info">
                        <tr>
                          <th width="50%" style="vertical-align: middle;">Fee Particular</th>
                          <th width="30%" style="text-align: center">Type</th>
                          <th style="text-align: center">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(f, i) in item.Child">
                          <td style="vertical-align: middle; width: 50%">{{f.Name}}</td>
                          <td v-if="ind == 0">
                            <select class="form-control" v-model="f.Type" v-on:change="feeTypeChange(f.Type, i)">
                              <option value="">--Select--</option>
                              <option value="Once">Once</option>
                              <option value="Annual">Annualy</option>
                              <option v-if="data1.IsAnnual == 'False'" value="Semester">Semester Wise</option>
                            </select>
                          </td>
                          <td width="30%" v-else>
                            <span v-if="f.Type == ''">Not Selected</span>
                            <span v-if="f.Type == 'Once'">Once</span>
                            <span v-if="f.Type == 'Annual'">Annualy</span>
                            <span v-if="f.Type == 'Semester'">Semester Wise</span>
                          </td>
                          <td v-if="ind == 0">
                            <input v-bind:disabled="f.Type == ''" class="form-control txtNumber" v-model="f.Fee" v-on:change="amountChange(f.Fee, i)" v-mask="'######'" required="required" />
                          </td>
                          <td v-else>
                            <input v-bind:disabled="f.Type == 'Once' || f.Type == ''" class="form-control txtNumber" v-model="f.Fee" v-mask="'######'" required="required" />
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="2" style="text-align: right">
                            <label>Total</label>
                          </td>
                          <td class="txtNumber">
                            <label>{{getTotal(ind).toLocaleString()}}</label>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group" style="border-top: 3px solid #343a40; margin-top: 20px ">
                  <h3 style="margin-top: 10px">Exceptional <span v-if="data1.IsAnnual == 'True'">Years</span> <span v-if="data1.IsAnnual == 'False'">Semesters</span></h3>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <table class="table table-bordered table-sm table-striped table-color" style="font-size: 12px;">
                    <thead class="bg-info">
                      <tr>
                        <th width="50%" style="vertical-align: middle;">Fee Particular</th>
                        <th width="30%" style="text-align: center">Type</th>
                        <th style="text-align: center">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="f in feeexceptional2">
                        <td style="vertical-align: middle; width: 30%">{{f.Name}}</td>
                        <td>
                          <select class="form-control" v-model="f.Type">
                            <option value="">--Select--</option>
                            <option value="Annual">Annualy</option>
                            <option v-if="data1.IsAnnual == 'False'" value="Semester">Semester Wise</option>
                          </select>
                        </td>
                        <td>
                          <input class="form-control txtNumber" v-bind:disabled="f.Type == ''" v-model="f.Fee" required="required" v-mask="'######'" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer" style="text-align: right;">
        <div class="col-md-12">
          <!--<button class="btn btn-primary pull-left" type="button" v-on:click="backClick()" v-if="activetab > 2">Back</button>-->
          <button class="btn btn-success" type="submit">Save</button>
          <button class="btn btn-danger" type="button" v-on:click="cancel()">Cancel</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>

  const axios = require('axios').default;

  export default ({
    props: {
      employeeId: Number,
      sendEmp: Function,
      sendImg: Function,
    },
    data() {
      return {
        records: [],
        copy: { ProgramID: '', SessionID: '', IsAnnual: 'False', IsOBE: false, FeeStyle: 'False', Duration: '0' },
        data1: { ProgramID: '', CategoryID: '', SessionID: '', IsAnnual: 'False', IsOBE: false, FeeStyle: 'False', Duration: '0' },
        data2: {},
        programs: [],
        sessions: [],
        feeheads: [],
        activetab: 2,
        selectedemp: [],
        feetype: [],
        feegrandtotal: 0,
        date: '',
        feescheme: [],
        feeexceptional: [],
        feescheme2: [],
        feeexceptional2: [],
        category: [],
        sameforall: true,
        width: '100%',
        semester: 0,
        coursetypeID: 0,
        courseID: 0, course: [], coursetype: [], theory: '', lab: '', description: '', KPI: '', semesters: [], alt: ""
      }
    },

    created: function () {
      this.pageLoad();
    },

    updated: function () {
      $('#tbl').DataTable();
    },


    methods: {
      pageLoad() {
        startReq();
        var vm = this;
        axios.post('/api/FeeApi/pageLoadFeeStructure')
          .then(function (response) {
            //var table = $('#tbl').DataTable();
            //table.destroy();
            if (response.data.status == "edit") {
              vm.programs = response.data["prog"];
              vm.sessions = response.data["ses"];
              vm.data1.ProgramID = response.data["progID"];
              vm.data1.SessionID = response.data["SessID"];
              vm.batchChange();
              vm.data1.CategoryID = response.data["catID"];
              axios.post('/api/FeeApi/loadFeeScheme?progID=' + vm.data1.ProgramID + '&sessID=' + vm.data1.SessionID + '&catID=' + vm.data1.CategoryID)
                .then(function (res) {
                  vm.feescheme = res.data["child"];
                  vm.feeexceptional = res.data["excep"];
                  endReq();
                });
            }
            else {
              vm.programs = response.data["prog"];
              vm.sessions = response.data["ses"];
            }
            endReq();
          })
      },

      btnNew() {
        this.isedit = true;
      },

      batchChange() {
        var vm = this;
        startReq();
        axios.post('/api/FeeApi/loadAdmissionCategory')
          .then(function (res) {
            endReq();
            vm.category = res.data;
          })
      },

      categoryChange() {
        var vm = this;
        startReq();
        axios.post('/api/FeeApi/loadFeeScheme?progID=' + vm.data1.ProgramID + '&sessID=' + vm.data1.SessionID + '&catID=' + vm.data1.CategoryID)
          .then(function (res) {
            vm.feescheme = res.data["child"];
            endReq();
            if (vm.feescheme.length == 0) {
              toastr.error("Program duration is not defined for this combination", "Error!");
            }
            else {
              vm.feeexceptional = res.data["excep"];
            }
          });
      },

      remove(ind, index) {

        this.semesters[ind].child.splice(index, 1);
      },

      value(Name) {
        var total = 0;
        var existing = this.semesters.find(x => x.Name == Name);
        if (existing == null) {

        }
        else {
          for (v in this.semesters) {
            if (this.semesters[v].Name == Name) {
              for (s in this.semesters[v].child) {
                total = total + this.semesters[v].child[s].CreditHours;
              }
            }
          }
        }
        return total;
      },

      loadRecord() {
        var vm = this;
        startReq();
        axios.post('/api/FeeApi/loadRecord')
          .then(function (response) {
            vm.records = response.data;
            endReq();
          })
      },

      edit(item) {
        startReq();
        var vm = this;
        vm.data1.SessionID = item.SessionID;
        vm.data1.ProgramID = item.ProgramID;
        vm.batchChange();
        vm.data1.CategoryID = item.CategoryID;
        axios.post('/api/FeeApi/loadFeeScheme?progID=' + vm.data1.ProgramID + '&sessID=' + vm.data1.SessionID + '&catID=' + vm.data1.CategoryID)
          .then(function (res) {
            vm.feescheme = res.data["child"];
            vm.feeexceptional = res.data["excep"];
            endReq();
          });
        vm.isedit = true;
      },

      cancel() {
        window.location.href = "../Fee/FeeStructureRecord";
      },

      nextClick(e) {
        e.preventDefault();
        if (this.activetab == 2) {
          startReq();
          var vm = this;

          axios.post('/api/FeeApi/saveFeeStructure?type=' + 'Regular' + '&skip=' + false, {
            feestructure: vm.data1,
            child: vm.feescheme,
            exceptional: vm.feeexceptional,
          })
            .then(function (res) {
              if (res.data == "success") {
                toastr.success("Saved Succussfully", "Done!");
                setTimeout(function () {
                  window.location.href = "../Fee/FeeStructure";
                  endReq();
                }, 1000);
                //vm.activetab = 3;
                //axios.post('/api/FeeApi/loadFeeScheme2?progID=' + vm.data1.ProgramID + '&sessID=' + vm.data1.SessionID)
                //  .then(function (r) {
                //    vm.feescheme2 = r.data["child"];
                //    vm.feeexceptional2 = r.data["excep"];
                //    endReq();
                //  });
                //document.body.scrollTop = 0;
                //document.documentElement.scrollTop = 0;
              }
              else {
                toastr.error(res.data.masg, "Error!");
              }
            })
        }

        else if (this.activetab == 3) {
          startReq();
          var vm = this;
          axios.post('/api/FeeApi/saveFeeStructure?type=' + 'Self' + '&skip=' + false, {
            feestructure: vm.data1,
            child: vm.feescheme2,
            exceptional: vm.feeexceptional2,
          })
            .then(function (res) {
              endReq();
              if (res.data == "success") {
                toastr.success("Saved Succussfully", "Done!");
                vm.activetab = 4;
              }
              else {
                toastr.error(res.data, "Error!");
              }
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;

            })
        }


      },

      // Fee Structure

      feeTypeChange(type, ind) {
        if (this.activetab == 2) {
          var fee = this.feescheme[0].Child[ind].Fee;
          for (var i = 1; i < this.feescheme.length; i++) {
            if (type == "Once") {
              this.feescheme[i].Child[ind].Fee = 0;
            }
            else if ((i % 2) != 0 && type == "Annual" && this.data1.IsAnnual == "False") {
              this.feescheme[i].Child[ind].Fee = 0;
            }
            else {
              this.feescheme[i].Child[ind].Fee = fee;
            }
            this.feescheme[i].Child[ind].Type = type;
          }
        }
        else {
          var fee = this.feescheme2[0].Child[ind].Fee;
          for (var i = 1; i < this.feescheme2.length; i++) {
            if (type == "Once") {
              this.feescheme2[i].Child[ind].Fee = 0;
            }
            else if ((i % 2) != 0 && type == "Annual" && this.data1.IsAnnual == "False") {
              this.feescheme2[i].Child[ind].Fee = 0;
            }
            else {
              this.feescheme2[i].Child[ind].Fee = fee;
            }
            this.feescheme2[i].Child[ind].Type = type;
          }
        }
      },

      amountChange(fee, ind) {
        if (this.activetab == 2) {
          for (var i = 1; i < this.feescheme.length; i++) {
            if (this.feescheme[i].Child[ind].Type == "Once") {
              this.feescheme[i].Child[ind].Fee = 0;
            }
            else if ((i % 2) != 0 && this.feescheme[i].Child[ind].Type == "Annual" && this.data1.IsAnnual == "False") {
              this.feescheme[i].Child[ind].Fee = 0;
            }
            else
              this.feescheme[i].Child[ind].Fee = fee;
          }
        }
        else {
          for (var i = 1; i < this.feescheme2.length; i++) {
            if (this.feescheme2[i].Child[ind].Type == "Once") {
              this.feescheme2[i].Child[ind].Fee = 0;
            }
            else if ((i % 2) != 0 && this.feescheme2[i].Child[ind].Type == "Annual" && this.data1.IsAnnual == "False") {
              this.feescheme2[i].Child[ind].Fee = 0;
            }
            else
              this.feescheme2[i].Child[ind].Fee = fee;
          }
        }

      },

      getTotal(ind) {
        if (this.activetab == 2) {
          var sum = 0;
          this.feescheme[ind].Child.forEach(function (item, index) {
            sum += Number(item.Fee);
          });
          return sum;
        }
        else {
          var sum = 0;
          this.feescheme2[ind].Child.forEach(function (item, index) {
            sum += Number(item.Fee);
          });
          return sum;
        }
      },

      getexecpTotal(ind) {
        if (this.activetab == 2) {
          var sum = 0;
          this.feeexceptional.forEach(function (item, index) {
            sum += Number(item.Fee);
          });
          return sum;
        }
      },

      getFeeGrandTotal() {
        this.feegrandtotal = 0;
        if (this.activetab == 2) {
          for (var i = 0; i < this.feescheme.length; i++) {
            this.feescheme[i].Child.forEach(function (item, index) {
              console.log(item.Fee);
              this.feegrandtotal += Number(item.Fee);
            });
          }
        }
        else {
          for (var i = 0; i < this.feescheme2.length; i++) {
            this.feescheme2[i].Child.forEach(function (item, index) {
              console.log(item.Fee);
              this.feegrandtotal += Number(item.Fee);
            });
          }
        }

        return this.feegrandtotal;
      },

      backClick() {
        this.activetab = Number(this.activetab) - 1;
      },

      clear() {
        this.isupdate = false;
        this.data = { Month: 0, Year: 0, Date: '', BonusTypeID: 0, Method: 0, Post: false, Students: [] };
        this.empcode = '';
        this.activetab = 1;
        this.selectedemp = [];
        this.designations = [];
        this.loadDepartment();
      }
    }
  })

  function allowOnlyNumber(evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/fee/feestructure.vue